import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import Button from "./Components/Button";

function Header({ sidebarOpen, onOpenSidebar, handleLogout }) {
  const location = useLocation();

  const pageTitleMap = {
    "/home": "CED ConTe s.r.l. - Home",
    "/condomini": "CED ConTe s.r.l. - Elenco Condomini",
    "/segnalazione": "CED ConTe s.r.l. - Segnalazioni",
    "/registro-segnalazioni": "CED ConTe s.r.l. - Segnalazioni",
    "/produzione-da-fatturare": "CED ConTe s.r.l. - Produzione da fatturare",
    "/fatture-insolute": "CED ConTe s.r.l. - Fatture insolute",
    "/Cont_Registra_Conciliazione": "CED ConTe s.r.l. - Registra conciliazione conto corrente",
    "/Cont_Registro_Conciliazioni": "CED ConTe s.r.l. - Registro conciliazioni CC",
  };

  const pageTitle = pageTitleMap[location.pathname] || "";

  return (
    <div style={{
      background: "linear-gradient(135deg, #1f2937, #374151)",
      padding: "10px 20px",
      color: "#ffffff",
      borderBottom: "1px solid rgba(255,255,255,0.1)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 350 }}>
        {!sidebarOpen && (
          <button onClick={onOpenSidebar}>☰</button>
        )}

        <div style={{ fontWeight: "bold", fontSize: "20px", whiteSpace: "nowrap" }}>
          {pageTitle}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Button variant="secondary" onClick={handleLogout}>
          Logout
        </Button>

        <img src="cedcontewhite.png" alt="Logo" style={{ height: "42px" }} />
      </div>
    </div>
  );
}


function parseJwt(token) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (err) {
    console.error("Errore parseJwt:", err);
    return null;
  }
}

function getCleanToken() {
  return localStorage.getItem("token")?.replace(/^['"]|['"]$/g, "");
}

function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("username");
  navigate("/login", { replace: true });
};
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const [openSections, setOpenSections] = useState({
    segnalazioni: false,
    menuProduzione: false,
    menuGestioneCondomini: false,
  });

  const [permissions, setPermissions] = useState({
    VAL1: false,
    VAL2: false,
    VAL3: false,
    VAL4: false,
  });

  useEffect(() => {
    if (location.pathname === "/home") {
      setSidebarOpen(true);
    } else {
      setSidebarOpen(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    const token = getCleanToken();

    if (!token) {
      setPermissions({
        VAL1: false,
        VAL2: false,
        VAL3: false,
        VAL4: false,
      });
      return;
    }

    const payload = parseJwt(token);

    console.log("PAYLOAD:", payload);

    if (!payload) {
      setPermissions({
        VAL1: false,
        VAL2: false,
        VAL3: false,
        VAL4: false,
      });
      return;
    }

   setPermissions({
    VAL1: Number(payload.VAL1) === 1,
    VAL2: Number(payload.VAL2) === 1,
    VAL3: Number(payload.VAL3) === 1,
    VAL4: Number(payload.VAL4) === 1,
  });
  }, []);

  const handleNavigate = () => {
    if (location.pathname !== "/home") {
      setSidebarOpen(false);
    }
  };

  const toggleSection = (sectionKey) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionKey]: !prev[sectionKey],
    }));
  };

  const menuSections = useMemo(
    () => [
      {
        key: "segnalazioni",
        label: "Gestione segnalazioni",
        visible: permissions.VAL1,
        items: [
          {
            label: "Registro segnalazioni",
            to: "/registro-segnalazioni",
          },
          {
            label: "Nuova segnalazione",
            to: "/segnalazione",
          },
        ],
      },
      {
        key: "menuProduzione",
        label: "CoGest",
        visible: permissions.VAL4,
        items: [
          {
            label: "Produzione da fatturare",
            to: "/Produzione-da-fatturare",
          },
          {
            label: "Fatture insolute",
            to: "/fatture-insolute",
          },
        ],
      },
      {
        key: "menuGestioneCondomini",
        label: "Condomini",
        visible: permissions.VAL2,
        items: [
          {
            label: "Registra conciliazione CC",
            to: "/Cont_Registra_Conciliazione",
            visible: permissions.VAL3,
          },
          {
            label: "Registro conciliazioni CC",
            to: "/Cont_Registro_Conciliazioni",
          },
        ],
      },
    ],
    [permissions]
  );

  return (
    <div style={{ display: "flex", height: "100vh", flexDirection: "column" }}>
    <Header
  sidebarOpen={sidebarOpen}
  onOpenSidebar={() => setSidebarOpen(true)}
  handleLogout={handleLogout}
/>

      <div style={{ display: "flex", flex: 1 }}>
        <div
          style={{
            width: sidebarOpen ? 220 : 14,
            transition: "width 0.25s ease",
            background: "linear-gradient(180deg, #111827 0%, #1f2937 100%)",
            padding: sidebarOpen ? 20 : 0,
            overflow: "hidden",
            borderRight: "1px solid rgba(255,255,255,0.1)",
            display: "flex",
            flexDirection: "column",
            color: "#ffffff",
          }}
        >
          {sidebarOpen && (
            <>
              <button
                onClick={() => setSidebarOpen(false)}
                style={{
                  alignSelf: "flex-end",
                  cursor: "pointer",
                  border: "1px solid rgba(255,255,255,0.25)",
                  background: "rgba(0,0,0,0.15)",
                  color: "white",
                  borderRadius: 10,
                  padding: "6px 10px",
                  marginBottom: 10,
                }}
              >
                ✕
              </button>

              <Button variant="secondary">
                <Link
                  style={{ color: "white", textDecoration: "none" }}
                  to="/home"
                  onClick={handleNavigate}
                >
                  Home
                </Link>
              </Button>

              <br />

              {menuSections
                .filter((section) => section.visible)
                .map((section) => {
                  const visibleItems = section.items.filter(
                    (item) => item.visible === undefined || item.visible
                  );

                  return (
                    <React.Fragment key={section.key}>
                      <Button
                        variant="secondary"
                        onClick={() => toggleSection(section.key)}
                      >
                        <span>{section.label}</span>
                        <span style={{ marginLeft: "10px" }}>
                          {openSections[section.key] ? "▼" : "▶"}
                        </span>
                      </Button>

                      {openSections[section.key] && (
                        <div style={{ marginTop: 10 }}>
                          {visibleItems.map((item, index) => (
                            <React.Fragment key={item.to}>
                              <Button>
                                <Link
                                  style={{
                                    color: "white",
                                    textDecoration: "none",
                                  }}
                                  to={item.to}
                                  onClick={handleNavigate}
                                >
                                  {item.label}
                                </Link>
                              </Button>

                              {index < visibleItems.length - 1 && (
                                <>
                                  <br />
                                  <br />
                                </>
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      )}

                      <br />
                    </React.Fragment>
                  );
                })}
            </>
          )}
        </div>

        <div
          style={{
            flex: 1,
            padding: "20px",
            overflowY: "auto",
            transition: "all 0.25s ease",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;